import React, { useEffect, useState } from "react";
import axios from "axios";
import { Eyebrow } from "@/components/brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const relTime = (iso) => {
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hr ago`;
  return `${Math.round(h / 24)} d ago`;
};

export const StudioProjectsPanel = () => {
  const token = localStorage.getItem("token");
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    axios.get(`${API}/studio/admin/projects`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setProjects(r.data.projects || []))
      .catch(() => setProjects([]));
  }, [token]);

  if (projects === null) return null;
  return (
    <div className="mt-12 card-flat p-6 md:p-8" data-testid="studio-projects-panel">
      <div className="flex items-baseline justify-between gap-4 mb-5">
        <div>
          <Eyebrow className="mb-2">Applicant Studio Projects</Eyebrow>
          <p className="text-xs text-mute">Build-out plans applicants have saved in the Design Studio. Read-only.</p>
        </div>
        <span className="font-mono text-xs text-mute" data-testid="studio-projects-count">{projects.length} saved</span>
      </div>
      {projects.length === 0 ? (
        <p className="text-sm text-mute" data-testid="studio-projects-empty">No applicant has saved a Studio project yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left eyebrow border-b border-line">
                <th className="py-2 pr-4 font-normal">Applicant</th>
                <th className="py-2 pr-4 font-normal">Project</th>
                <th className="py-2 pr-4 font-normal">License type</th>
                <th className="py-2 pr-4 font-normal text-right">Size</th>
                <th className="py-2 pr-4 font-normal text-right">Rooms</th>
                <th className="py-2 font-normal text-right">Last saved</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((p) => (
                <tr key={p.id} className="border-b border-line/60 last:border-0" data-testid={`studio-project-row-${p.id}`}>
                  <td className="py-2.5 pr-4 text-ink-2">
                    <span className="font-medium text-ink">{p.owner_name || p.owner_email}</span>
                    {p.owner_name && <span className="block text-xs text-mute font-mono">{p.owner_email}</span>}
                  </td>
                  <td className="py-2.5 pr-4 font-semibold text-ink">{p.name}{p.addr && <span className="block text-xs text-mute font-normal">{p.addr}</span>}</td>
                  <td className="py-2.5 pr-4 text-ink-2">{p.use_name || p.use || "—"}</td>
                  <td className="py-2.5 pr-4 text-right font-mono text-ink-2">{p.sqft ? `${p.sqft.toLocaleString()} sf` : "—"}</td>
                  <td className="py-2.5 pr-4 text-right font-mono text-ink-2">{p.room_count}</td>
                  <td className="py-2.5 text-right text-mute text-xs">{relTime(p.updated_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
